import { effectiveCurrentMonth } from './effectiveMonth';

// Always returns the CURRENT EFFECTIVE month ('YYYY-MM'). Every section defaults its
// month filter to the current month only, regardless of whether that month's data has
// landed yet. `months` is accepted for backwards compatibility with the /filters
// endpoints but is intentionally unused.
// [EFFECTIVE-MONTH 2026-07-01] Delegates to effectiveCurrentMonth() so the default
// respects the app-wide 12:30 PM IST rollover on the 1st (until then the previous month
// is still "current"), instead of flipping at local midnight.
export function latestDataMonth(_months?: string[]): string {
  return effectiveCurrentMonth();
}
